// =====================================================================
// src/lib/bloqueio.js — o quarto bloqueado (0067), sem DOM
//
// O "Bloqueio manual" do MdM (index.html 10430, modal do flat): Nenhum
// (automático por reservas) · Indisponível (manutenção / bloqueado) ·
// Manutenção. Aqui é `unidades.bloqueio` (nulo · indisponivel ·
// manutencao), gravado só por `definir_bloqueio`.
//
// QUEM BLOQUEIA — um responsável por quarto (Hugo, 26/09/2026):
//   · quarto de imobiliária → a imobiliária (quem edita
//     reservas dela);
//   · quarto sem imobiliária → a administração do hotel.
// O ramo do "proprietário particular sem imobiliária", que bloqueava o
// próprio quarto pelo login de dono, saiu na 0101 com o login (Hugo,
// 02/11/2026: "o proprietário não tem acesso a nenhuma informação … salvo
// ele seja considerado como uma imobiliária"). Para a tela, quarto sem
// imobiliária é do hotel, tenha ou não `proprietario_id` — o hotel nem vê
// mais o dono. SE o banco da 0101 tiver decidido que esse quarto fica sem
// ninguém, a tela mostra o seletor e o banco recusa: a direção permitida
// pela regra abaixo, nunca a inversa.
// `possoBloquear` é o ESPELHO de `app.posso_bloquear` (0067) — decide só
// se o seletor aparece. Quem decide de verdade é o banco: se os dois
// divergirem, a tela mostra o seletor e o banco recusa, nunca o contrário.
// =====================================================================

// As opções, com o texto do MdM, na ordem dele. '' = Nenhum.
export const OPCOES_BLOQUEIO = Object.freeze([
  { valor: '', rotulo: 'Nenhum (automático por reservas)' },
  { valor: 'indisponivel', rotulo: 'Indisponível (manutenção / bloqueado)' },
  { valor: 'manutencao', rotulo: 'Manutenção' },
]);

// O rótulo curto (pendências, alerta, grade de Configurações).
export const ROTULO_BLOQUEIO = Object.freeze({ indisponivel: 'Indisponível', manutencao: 'Manutenção' });
export const rotuloDoBloqueio = b => ROTULO_BLOQUEIO[b] || '';

export function possoBloquear(unidade, contexto) {
  const u = unidade || {}, c = contexto || {};
  if (!u.id || u.ativo === false) return false;
  if (c.usuario && c.usuario.sistema) return false;
  const adm = c.imobiliaria && c.imobiliaria.id;
  if (u.imobiliaria_id) {
    const nivel = ((Array.isArray(c.modulos) ? c.modulos : []).find(m => m && m.chave === 'reservas') || {}).nivel;
    return !!adm && u.imobiliaria_id === adm && nivel === 'editar';
  }
  return !adm && !!(c.papel && c.papel.chave === 'administracao');
}

// O que vai para `definir_bloqueio`: '' (Nenhum) vira nulo; o resto só
// se for da lista.
export function valorParaGravar(v) {
  if (v === '' || v === null || v === undefined) return null;
  return OPCOES_BLOQUEIO.some(o => o.valor === v) ? v : undefined;
}

// A frase depois de bloquear: quantas reservas ficaram no quarto.
export function avisoDoBloqueio(numero, bloqueio, n) {
  if (!bloqueio) return `Quarto ${numero} desbloqueado.`;
  const base = `Quarto ${numero} bloqueado (${rotuloDoBloqueio(bloqueio)}).`;
  if (!n) return base;
  return `${base} ${n === 1 ? 'Ficou 1 reserva' : `Ficaram ${n} reservas`} nele — ${n === 1 ? 'ela aparece' : 'elas aparecem'} em "Reservas em quarto bloqueado" para resolver.`;
}
